var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle202ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 176 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M13.327 15H162.67c1.655 0 3.106.267 4.108.662.503.2.843.411 1.041.596a.79.79 0 0 1 .163.198c.01.02.014.032.016.037l.001.006v15.002l-.001.006c-.002.005-.006.018-.016.037a.79.79 0 0 1-.163.198c-.198.185-.538.397-1.041.596-1.002.396-2.453.662-4.108.662H13.327c-1.654 0-3.106-.267-4.108-.662-.503-.2-.843-.412-1.04-.596a.779.779 0 0 1-.164-.198.191.191 0 0 1-.015-.037l-.001-.006V16.493a.192.192 0 0 1 .016-.037.78.78 0 0 1 .163-.198c.198-.184.538-.397 1.041-.596 1.002-.396 2.454-.662 4.108-.662Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M10.793 44.726A2.5 2.5 0 0 0 13.283 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6A2.5 2.5 0 0 0 19.262 36h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M12.738 46a1.812 1.812 0 0 1-1.62-1.002l-.223-.445a1 1 0 1 0-1.79.894l.223.445A3.813 3.813 0 0 0 12.738 48h6.524a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 1 0-1.79-.894l-.222.445A1.812 1.812 0 0 1 19.262 46h-6.524Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M26.792 44.726A2.5 2.5 0 0 0 29.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 35.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M28.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 28.737 48h6.524a3.812 3.812 0 0 0 3.41-2.108l.222-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 35.26 46h-6.524Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M42.792 44.726A2.5 2.5 0 0 0 45.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 51.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M44.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 44.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 51.26 46h-6.524Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M58.792 44.726A2.5 2.5 0 0 0 61.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 67.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M60.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 60.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 67.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M74.792 44.726A2.5 2.5 0 0 0 77.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 83.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M76.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 76.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 83.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M90.792 44.726A2.5 2.5 0 0 0 93.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 99.261 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M92.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 92.737 48h6.523a3.813 3.813 0 0 0 3.411-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 99.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M106.792 44.726A2.5 2.5 0 0 0 109.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M108.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 115.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M122.792 44.726A2.5 2.5 0 0 0 125.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M124.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 131.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M10.793 3.274A2.5 2.5 0 0 1 13.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 19.262 12h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M12.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 12.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 19.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M26.792 3.274A2.5 2.5 0 0 1 29.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 35.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M28.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 28.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 35.26 2h-6.524Z",
  clipRule: "evenodd"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M42.792 3.274A2.5 2.5 0 0 1 45.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 51.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M44.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 44.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 51.26 2h-6.524Z",
  clipRule: "evenodd"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M58.792 3.274A2.5 2.5 0 0 1 61.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 67.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M60.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 60.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 67.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M74.792 3.274A2.5 2.5 0 0 1 77.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 83.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M76.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 76.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 83.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M90.792 3.274A2.5 2.5 0 0 1 93.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 99.261 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M92.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 92.737 0h6.523c1.445 0 2.765.816 3.411 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 99.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M106.792 3.274A2.5 2.5 0 0 1 109.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M108.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 108.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 115.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M122.792 3.274A2.5 2.5 0 0 1 125.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M124.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 124.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 131.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M138.792 3.274A2.5 2.5 0 0 1 141.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M140.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 140.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 147.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M154.792 3.274A2.5 2.5 0 0 1 157.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M156.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 156.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 163.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M138.792 44.726A2.5 2.5 0 0 0 141.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M140.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 147.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M154.792 44.726A2.5 2.5 0 0 0 157.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M156.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 163.261 46h-6.524Z",
  clipRule: "evenodd"
})));
SvgRectangle202ASelected.viewBox = '0 0 176 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle202ASelected);
export default ForwardRef;